export const START_PAYMENT_WITH_SLYDE = 'START_PAYMENT_WITH_SLYDE';
export const PAYMENT_WITH_SLYDE_SUCCESS = 'PAYMENT_WITH_SLYDE_SUCCESS';
export const PAYMENT_WITH_SLYDE_FAILED = 'PAYMENT_WITH_SLYDE_FAILED';
export const START_PAYMENT_WITH_THE_TELLER = 'START_PAYMENT_WITH_THE_TELLER';
export const PAYMENT_WITH_THE_TELLER_SUCCESS =
  'PAYMENT_WITH_THE_TELLER_SUCCESS';
export const PAYMENT_WITH_THE_TELLER_FAILED = 'PAYMENT_WITH_THE_TELLER_FAILED';
